import { isNumeric } from '../utils/numeric.utils';
import { emptyValue, TypedFormControl } from '../utils/typed-forms';

interface GetRateFromLifeApiModelRequest {
  regimeId: number;
  depreciationMethodId?: number | string | null | undefined;
  life: number;
  firstUseDate?: string;
  date?: string;
}
interface GetRateFromEndDateApiModelRequest {
  regimeId: number;
  depreciationMethodId?: number | string | null | undefined;
  endDate: string;
  firstUseDate: string;
  date?: string;
}

export type GetRateApiModelRequest =
  | GetRateFromLifeApiModelRequest
  | GetRateFromEndDateApiModelRequest;

interface GetRateFromLifeRequestOptions {
  regimeId: number;
  depreciationMethodId?: number | string | null | undefined;
  life: number | null | undefined;
  firstUseDate: string | undefined;
  date?: string | undefined;
}
interface GetRateFromEndDateRequestOptions {
  regimeId: number;
  depreciationMethodId?: number | string | null | undefined;
  endDate: string | null | undefined;
  firstUseDate: string | undefined;
  date?: string | undefined;
}

export type GetRateRequestOptions =
  | GetRateFromLifeRequestOptions
  | GetRateFromEndDateRequestOptions;

const isValidEndDateRequest = (
  options: GetRateFromEndDateRequestOptions,
): options is GetRateFromEndDateRequestOptions & { endDate: string; firstUseDate: string } =>
  !!options.endDate && !!options.firstUseDate;

const isValidLifeRequest = (
  options: GetRateFromLifeRequestOptions,
): options is GetRateFromLifeRequestOptions & { life: number } => isNumeric(options.life);

export const getValidRateRequest = ((
  options: GetRateRequestOptions,
  rateControl?: TypedFormControl<number>,
): GetRateApiModelRequest | undefined => {
  if (
    !options.regimeId ||
    !options.depreciationMethodId ||
    (rateControl && rateControl.enabled && rateControl.dirty && rateControl.value)
  ) {
    return undefined;
  }

  let result: GetRateApiModelRequest;

  if ('endDate' in options) {
    if (isValidEndDateRequest(options)) {
      result = {
        ...options,
        date: options.date || options.firstUseDate,
      };
    } else {
      return undefined;
    }
  } else if ('life' in options) {
    if (isValidLifeRequest(options)) {
      result = options;
    } else {
      return undefined;
    }
  } else {
    return undefined;
  }

  if (rateControl) {
    if (rateControl.enabled) {
      rateControl.markAsPending();
    } else {
      rateControl.setValue(emptyValue<number>());
    }
  }

  return result;
}) as {
  (
    options: GetRateFromLifeRequestOptions,
    rateControl?: TypedFormControl<number>,
  ): GetRateFromLifeApiModelRequest | undefined;
  (
    options: GetRateFromEndDateRequestOptions,
    rateControl?: TypedFormControl<number>,
  ): GetRateFromEndDateApiModelRequest | undefined;
};
